import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Col,
  Row,
  Container,
  Card,
  CardBody,
  Input,
  Button,
  Table,
} from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"

import Spinners from "components/Common/Spinner"
import { useNavigate, useParams } from "react-router-dom"
import EstimateCostBlock from "./components/EstimateCostBlock"
import TotalFeeBlock from "./components/TotalFeeBlock"
import { get } from "helpers/api_helper"

const SurveyOrderCampaignView = (props) => {
  const navigate = useNavigate()
  const { campaignId } = useParams()

  const [isLoading, setIsLoading] = useState(true)
  const [searchText, setSearchText] = useState("")

  const [campaignStatus, setCampaignStatus] = useState("End - Quota Reached")
  const [statsData, setStatsData] = useState(null)

  const fetchCampaignStats = async () => {
    try {
      const result = await get(
        process.env.REACT_APP_BACKEND_URL + "/v1/admin/campaign/" + campaignId + "/stats"
      )
      if (result?.status === "200" && result?.data) {
        setStatsData(result.data)
      }
    } catch (e) {
      console.error("fetchCampaignStats err >>", e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchCampaignStats()
  }, [campaignId])

  const handleExport = () => {
    console.log("Export clicked")
    // TODO: Implement export logic
  }

  const handleDownloadInvoice = () => {
    console.log("Download Invoice clicked")
    // TODO: Implement download invoice logic
  }

  const isCampaignEnded = campaignStatus.startsWith("End")

  const groups = statsData?.groups ?? []

  const filteredGroups = groups.filter(item =>
    String(item.group_index).includes(searchText)
  )

  document.title = "View Campaign | " + process.env.REACT_APP_CMS_TITLE

  if (isLoading) {
    return <Spinners setLoading={setIsLoading} />
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        {/* Breadcrumbs */}
        <Breadcrumbs
          title={"View Campaign"}
          breadcrumbItems={[
            { title: "Survey Order Campaign", link: "survey-order-campaign" },
            { title: "View Campaign", link: `view/${campaignId}` },
          ]}
        />

        {/* Response Status Report Block */}
        <Row>
          <Col>
            <Card style={{ borderRadius: "8px", overflow: "hidden" }}>
              <div
                className="p-3"
                style={{
                  backgroundColor: "#E6F8F3",
                  color: "#1a5d3a",
                  fontWeight: "600",
                  fontSize: "1.1rem",
                  borderTopLeftRadius: "8px",
                  borderTopRightRadius: "8px",
                }}
              >
                Response Status Report
              </div>
              <CardBody>
                {/* Search bar and Export button */}
                <Row className="mb-3">
                  <Col className="d-flex justify-content-between align-items-center">
                    <div style={{ width: "300px" }}>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                      />
                    </div>
                    <Button
                      type="button"
                      color="success"
                      onClick={handleExport}
                    >
                      <i className="bx bx-export me-1"></i>
                      Export
                    </Button>
                  </Col>
                </Row>

                {/* Table */}
                <div className="table-responsive">
                  <Table className="table table-bordered table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Group</th>
                        <th>Qualified</th>
                        <th>Attended</th>
                        <th>Basic</th>
                        <th>10 Points</th>
                        <th>20 Points</th>
                        <th>30 Points</th>
                        <th>40 Points</th>
                        <th>Unfinished</th>
                        <th>Unpassed</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredGroups.length > 0 ? (
                        filteredGroups.map((item) => {
                          const attended = item.group_maximum_samples - item.unused
                          const qualified = `${item.pass}/${item.group_target_number}(${item.group_maximum_samples})`
                          return (
                            <tr key={item.group_id}>
                              <td>{`Group ${item.group_index}`}</td>
                              <td>{qualified}</td>
                              <td>{attended}</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td>-</td>
                              <td>{item.unfinished}</td>
                              <td>{item.fail}</td>
                            </tr>
                          )
                        })
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Estimate Cost Block or Total Fee Block based on campaign status */}
        <Row className="mt-4">
          <Col>
            {isCampaignEnded ? (
              <TotalFeeBlock onDownloadInvoice={handleDownloadInvoice} />
            ) : (
              <EstimateCostBlock mode="view" />
            )}
          </Col>
        </Row>

        {/* Back Button */}
        <Row className="mt-3">
          <Col>
            <Button
              type="button"
              outline
              color="secondary"
              onClick={() => navigate("/survey-order-campaign")}
            >
              <i className="bx bx-arrow-back me-1"></i>
              Back
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

SurveyOrderCampaignView.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(SurveyOrderCampaignView)
